<template>
  <div>
    <div v-if="!formListLoader">
      <div>
        <v-switch
          v-model="checkRelative"
          inset
          @click="onClickRelativeToggle()"
        >
          <template v-slot:label>
            Do you have any relatives working in this company?
          </template>
        </v-switch>
      </div>
      <div v-if="checkRelative">
        <v-form>
          <ValidationObserver ref="relativeForm">
            <v-row>
              <v-col cols="12">
                <v-card flat class="pa-6">
                  <v-row>
                    <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                      <ValidationProvider
                        ref="rFirstNameProvider"
                        v-slot="{ errors }"
                        name="Relative Name"
                        rules="required|multilingualNameValidation"
                      >
                        <v-text-field
                          :id="'Relative_Name'"
                          v-model="relative.name"
                          outlined
                          :maxlength="150"
                          :error-messages="errors"
                        >
                          <template v-slot:label>
                            Relative Name
                            <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                      <ValidationProvider
                        ref="rPositionProvider"
                        v-slot="{ errors }"
                        name="Position"
                        rules="required|positionValidation"
                      >
                        <v-text-field
                          :id="'Relative_Position'"
                          v-model="relative.position"
                          outlined
                          :maxlength="30"
                          :error-messages="errors"
                        >
                          <template v-slot:label>
                            Position
                            <span style="color: red">*</span>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col
                      v-if="
                        formList[768] &&
                        formList[768].Field_Visiblity.toLowerCase() === 'yes'
                      "
                      cols="12"
                      xs="12"
                      sm="6"
                      lg="6"
                      md="6"
                      xl="6"
                    >
                      <ValidationProvider
                        ref="rDepartmentProvider"
                        v-slot="{ errors }"
                        :name="formList[768].Field_Alias"
                        :rules="
                          formList[768].Mandatory_Field.toLowerCase() === 'yes'
                            ? 'required'
                            : ''
                        "
                      >
                        <v-text-field
                          :id="'Department'"
                          v-model="relative.department"
                          outlined
                          :counter="50"
                          :maxlength="50"
                          :error-messages="errors"
                        >
                          <template v-slot:label>
                            {{ formList[768].Field_Alias }}
                            <span
                              v-if="
                                formList[768].Mandatory_Field.toLowerCase() ===
                                'yes'
                              "
                              style="color: red"
                              >*</span
                            >
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-form>
      </div>
      <div class="d-flex justify-end mb-3">
        <v-btn color="primary" text @click="addMoreDependent()">
          <v-icon>add</v-icon>
          Add Dependent
        </v-btn>
      </div>
      <v-form
        v-for="(dependent, index) in addDependent"
        :key="index"
        :ref="'dependentForm' + index"
      >
        <div
          v-if="addDependent.length > 1 || dependent.dependentId"
          class="d-flex justify-end mb-3"
        >
          <v-btn
            color="primary lighten-1"
            text
            @click="removeDependentDetails(index, dependent)"
          >
            <v-icon>delete</v-icon>
            Remove
          </v-btn>
        </div>
        <ValidationObserver :ref="'dependentForm' + index">
          <v-row>
            <v-col cols="12">
              <v-card flat class="pa-6">
                <v-row>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <ValidationProvider
                      ref="dFirstNameProvider"
                      v-slot="{ errors }"
                      name="First Name"
                      rules="required|multilingualNameValidation"
                    >
                      <v-text-field
                        :id="'First_Name'"
                        v-model="dependent.dFirstName"
                        outlined
                        label="First Name*"
                        :counter="50"
                        :maxlength="50"
                        :error-messages="errors"
                        @change="isFormDirty = true"
                        @input="isFormDirty = true"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <ValidationProvider
                      ref="dLastNameProvider"
                      v-slot="{ errors }"
                      name="Last Name"
                      rules="required|multilingualNameValidation"
                    >
                      <v-text-field
                        :id="'Last_Name'"
                        v-model="dependent.dLastName"
                        outlined
                        label="Last Name*"
                        :counter="50"
                        :maxlength="50"
                        :error-messages="errors"
                        @change="isFormDirty = true"
                        @input="isFormDirty = true"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <ValidationProvider
                      ref="relationshipProvider"
                      v-slot="{ errors }"
                      name="Relationship"
                      rules="required"
                    >
                      <v-autocomplete
                        :id="'RelationShip'"
                        v-model="dependent.dRelation"
                        outlined
                        label="Relationship*"
                        :items="relationshipList"
                        item-text="Dependent_Relationship"
                        item-value="Dependent_Relationship"
                        :error-messages="errors"
                        @change="isFormDirty = true"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <v-dialog v-model="dependent.dependentDobModal" width="290">
                      <template #activator="{ on }">
                        <ValidationProvider
                          ref="dDobProvider"
                          v-slot="{ errors }"
                          name="DOB"
                          rules="required"
                        >
                          <v-text-field
                            :id="'DependentDob'"
                            :value="formatDate(dependent.dDob)"
                            outlined
                            readonly
                            label="Date of Birth*"
                            v-on="on"
                            :error-messages="errors"
                            @change="isFormDirty = true"
                            @input="isFormDirty = true"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        v-model="dependent.dDob"
                        :max="maxYearDependent"
                        @change="dependent.dependentDobModal = false"
                      ></v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <ValidationProvider
                      ref="genderProvider"
                      v-slot="{ errors }"
                      name="Gender"
                      rules="required"
                    >
                      <v-select
                        :id="'Gender'"
                        v-model="dependent.gender"
                        outlined
                        :items="genderList"
                        item-text="gender"
                        item-value="genderId"
                        :error-messages="errors"
                        label="Gender*"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[777] &&
                      formList[777].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                  >
                    <ValidationProvider
                      ref="dAddressProvider"
                      v-slot="{ errors }"
                      :name="formList[777].Field_Alias"
                      :rules="
                        formList[777].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required'
                          : ''
                      "
                    >
                      <v-text-field
                        :id="'Dependent_Address'"
                        v-model="dependent.dAddress"
                        outlined
                        :counter="250"
                        :maxlength="250"
                        :error-messages="errors"
                        @change="isFormDirty = true"
                        @input="isFormDirty = true"
                      >
                        <template v-slot:label>
                          {{ formList[777].Field_Alias }}
                          <span
                            v-if="
                              formList[777].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          ></template
                        >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[778] &&
                      formList[778].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                  >
                    <ValidationProvider
                      ref="dMobileNumberProvider"
                      v-slot="{ errors }"
                      :name="formList[778].Field_Alias"
                      :rules="
                        formList[778].Mandatory_Field.toLowerCase() === 'yes'
                          ? `required|min:${
                              formList[778].Min_Validation || 1
                            }|max:${formList[778].Max_Validation || 15}|regex:${
                              formList[778].Validation_Id || 5
                            }`
                          : `min:${formList[778].Min_Validation || 1}|max:${
                              formList[778].Max_Validation || 15
                            }|regex:${formList[778].Validation_Id || 5}`
                      "
                    >
                      <v-text-field
                        :id="'Dependent_Mobile_Number'"
                        v-model="dependent.dMobileNumber"
                        outlined
                        :counter="formList[778].Max_Validation || 15"
                        :maxlength="formList[778].Max_Validation || 15"
                        :error-messages="errors"
                        @change="isFormDirty = true"
                        @input="isFormDirty = true"
                      >
                        <template v-slot:label>
                          {{ formList[778].Field_Alias }}
                          <span
                            v-if="
                              formList[778].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          ></template
                        >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[779] &&
                      formList[779].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                  >
                    <ValidationProvider
                      ref="dPANProvider"
                      v-slot="{ errors }"
                      :name="formList[779].Field_Alias"
                      :rules="
                        formList[779].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required'
                          : ''
                      "
                    >
                      <v-text-field
                        :id="'Dependent_PAN'"
                        v-model="dependent.dPAN"
                        outlined
                        :counter="50"
                        :maxlength="50"
                        :error-messages="errors"
                        @change="isFormDirty = true"
                        @input="isFormDirty = true"
                      >
                        <template v-slot:label>
                          {{ formList[779].Field_Alias }}
                          <span
                            v-if="
                              formList[779].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          ></template
                        >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <ValidationProvider
                      ref="nationalityProvider"
                      v-slot="{ errors }"
                      name="Nationality"
                      rules="required"
                    >
                      <v-autocomplete
                        :id="'Nationality'"
                        v-model="dependent.nationality"
                        outlined
                        :items="nationalityList"
                        item-text="nationality"
                        item-value="nationality"
                        :error-messages="errors"
                        label="Nationality*"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
                    <v-switch
                      v-model="dependent.isAdopted"
                      inset
                      color="primary"
                      :true-value="1"
                      :false-value="0"
                      label="Is Adopted?"
                      @change="isFormDirty = true"
                    ></v-switch>
                  </v-col>
                  <v-col
                    v-if="dependent.isAdopted"
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                  >
                    <v-dialog
                      v-model="dependent.dependentAdoptionDateModal"
                      width="290"
                    >
                      <template #activator="{ on }">
                        <ValidationProvider
                          ref="dAdoptionDateProvider"
                          v-slot="{ errors }"
                          name="Adoption Date"
                          rules="required"
                        >
                          <v-text-field
                            :id="'DependentAdoptionDate'"
                            :value="formatDate(dependent.dAdoptionDate)"
                            outlined
                            readonly
                            label="Adoption Date*"
                            v-on="on"
                            :error-messages="errors"
                            @change="isFormDirty = true"
                            @input="isFormDirty = true"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        v-model="dependent.dAdoptionDate"
                        :max="maxYearDependent"
                        @change="dependent.dependentAdoptionDateModal = false"
                      ></v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
                <v-row v-if="presentNominationDetails">
                  <v-col
                    cols="12"
                    class="d-flex justify-start text-subtitle-1 font-weight-bold"
                  >
                    Nomination Details
                  </v-col>
                  <v-col
                    v-if="
                      formList[1030] &&
                      formList[1030].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <ValidationProvider
                      ref="epfNominationProvider"
                      v-slot="{ errors }"
                      :name="formList[1030].Field_Alias"
                      :rules="
                        formList[1030].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required|percentageValidation|minimum:0|maximum:100'
                          : 'percentageValidation|minimum:0|maximum:100'
                      "
                    >
                      <v-text-field
                        :id="'EPFNomination'"
                        v-model="dependent.epfNomination"
                        outlined
                        type="number"
                        :label="formList[1030].Field_Alias"
                        :min="0"
                        :max="100"
                        step="1"
                        :error-messages="errors"
                        @input="handleNominationInput"
                      >
                        <template v-slot:label>
                          {{ formList[1030].Field_Alias }}
                          <span
                            v-if="
                              formList[1030].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[1031] &&
                      formList[1031].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <ValidationProvider
                      ref="epsNominationProvider"
                      v-slot="{ errors }"
                      :name="formList[1031].Field_Alias"
                      :rules="
                        formList[1031].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required|percentageValidation|minimum:0|maximum:100'
                          : 'percentageValidation|minimum:0|maximum:100'
                      "
                    >
                      <v-text-field
                        :id="'EPSNomination'"
                        v-model="dependent.epsNomination"
                        outlined
                        type="number"
                        :label="formList[1031].Field_Alias"
                        :min="0"
                        :max="100"
                        step="1"
                        :error-messages="errors"
                        @input="handleNominationInput"
                      >
                        <template v-slot:label>
                          {{ formList[1031].Field_Alias }}
                          <span
                            v-if="
                              formList[1031].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[1032] &&
                      formList[1032].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <ValidationProvider
                      ref="insuranceNominationProvider"
                      v-slot="{ errors }"
                      :name="formList[1032].Field_Alias"
                      :rules="
                        formList[1032].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required|percentageValidation|minimum:0|maximum:100'
                          : 'percentageValidation|minimum:0|maximum:100'
                      "
                    >
                      <v-text-field
                        :id="'InsuranceNomination'"
                        v-model="dependent.insuranceNomination"
                        outlined
                        type="number"
                        :label="formList[1032].Field_Alias"
                        :min="0"
                        :max="100"
                        step="1"
                        :error-messages="errors"
                        @input="handleNominationInput"
                      >
                        <template v-slot:label>
                          {{ formList[1032].Field_Alias }}
                          <span
                            v-if="
                              formList[1032].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[1033] &&
                      formList[1033].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <ValidationProvider
                      ref="othersNominationProvider"
                      v-slot="{ errors }"
                      :name="formList[1033].Field_Alias"
                      :rules="
                        formList[1033].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required|percentageValidation|minimum:0|maximum:100'
                          : 'percentageValidation|minimum:0|maximum:100'
                      "
                    >
                      <v-text-field
                        :id="'OthersNomination'"
                        v-model="dependent.othersNomination"
                        outlined
                        type="number"
                        :label="formList[1033].Field_Alias"
                        :min="0"
                        :max="100"
                        step="1"
                        :error-messages="errors"
                        @input="handleNominationInput"
                      >
                        <template v-slot:label>
                          {{ formList[1033].Field_Alias }}
                          <span
                            v-if="
                              formList[1033].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[1034] &&
                      formList[1034].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <ValidationProvider
                      ref="gratuityNominationProvider"
                      v-slot="{ errors }"
                      :name="formList[1034].Field_Alias"
                      :rules="
                        formList[1034].Mandatory_Field.toLowerCase() === 'yes'
                          ? 'required|percentageValidation|minimum:0|maximum:100'
                          : 'percentageValidation|minimum:0|maximum:100'
                      "
                    >
                      <v-text-field
                        :id="'GratuityNomination'"
                        v-model="dependent.gratuityNomination"
                        outlined
                        type="number"
                        :label="formList[1034].Field_Alias"
                        :min="0"
                        :max="100"
                        step="1"
                        :error-messages="errors"
                        @input="handleNominationInput"
                      >
                        <template v-slot:label>
                          {{ formList[1034].Field_Alias }}
                          <span
                            v-if="
                              formList[1034].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    v-if="
                      formList[1035] &&
                      formList[1035].Field_Visiblity.toLowerCase() === 'yes'
                    "
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <ValidationProvider
                      ref="emergencyContactReferenceProvider"
                      v-slot="{ errors }"
                      :name="formList[1035].Field_Alias"
                      :rules="
                        formList[1035].Mandatory_Field.toLowerCase() ===
                          'yes' && dependent.emergencyContactReference !== ''
                          ? 'required'
                          : ''
                      "
                    >
                      <v-select
                        :id="'EmergencyContactReference'"
                        v-model="dependent.emergencyContactReference"
                        outlined
                        :items="emergencyContactReferenceOptions"
                        item-text="text"
                        item-value="value"
                        :label="formList[1035].Field_Alias"
                        :error-messages="errors"
                        @change="handleNominationInput"
                      >
                        <template v-slot:label>
                          {{ formList[1035].Field_Alias }}
                          <span
                            v-if="
                              formList[1035].Mandatory_Field.toLowerCase() ===
                              'yes'
                            "
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </ValidationObserver>
        <v-divider></v-divider>
      </v-form>
      <div class="mt-3 d-flex justify-end">
        <v-btn
          color="primary"
          style="border-radius: 10px"
          large
          :disabled="!checkRelative && !isFormDirty && !noDependents"
          :loading="saveLoading"
          @click="onSaveDependent()"
          >Save & Continue</v-btn
        >
      </div>
    </div>
    <v-overlay absolute :value="formListLoader" color="#fff" z-index="1">
      <v-progress-circular color="primary" indeterminate size="50" />
    </v-overlay>
  </div>
</template>

<script>
import {
  GET_DEPENDENT,
  ADD_DEPENDENT,
  UPDATE_DEPENDENT,
  DELETE_DEPENDENT,
  LIST_GENDERS,
  LIST_NATIONALITY,
  GET_FORM_FIELDS_AND_TYPE,
  UPDATE_PERSONAL_INFO,
  ADD_UPDATE_RELATIVE,
  REMOVE_RELATIVE,
} from "@/graphql/OnboardingQueries";
import moment from "moment";
import { scrollScreenToTop } from "../../../helper";

export default {
  name: "DependentInfo",

  props: {
    relationshipList: {
      type: Array,
      required: true,
    },
    noDependents: {
      type: Boolean,
      required: false,
    },
    personalInfo: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    addDependent: [],
    relative: {},
    maxYearDependent: "",
    apiCallCount: 0,
    saveLoading: false,
    genderList: [],
    nationalityList: [],
    isFormDirty: false,
    checkRelative: true,
    relativeTabSaved: true,
    dependentTabSaved: true,
    formList: [],
    formListLoader: false,
    emergencyContactReferenceOptions: [
      { text: "Primary", value: "Primary" },
      { text: "Secondary", value: "Secondary" },
      { text: "Other Reference", value: "" },
    ],
  }),

  created() {
    this.maxYearDependent = moment().format("YYYY-MM-DD");
  },

  apollo: {
    retrieveNationalityList: {
      query: LIST_NATIONALITY,
      client: "apolloClientA",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
        };
      },
      result({ data }) {
        if (data && data.retrieveNationalityList) {
          this.nationalityList = data.retrieveNationalityList.nationalityData;
        }
      },
    },
    retrieveGenderList: {
      query: LIST_GENDERS,
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
        };
      },
      result({ data }) {
        if (
          data &&
          data.retrieveGenderList &&
          data.retrieveGenderList.genderData
        ) {
          this.genderList = data.retrieveGenderList.genderData;
        }
      },
    },
    getDependent: {
      query: GET_DEPENDENT,
      client: "apolloClientA",
      fetchPolicy: "no-cache",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
          Url_Hash: localStorage.getItem("urlHash"),
        };
      },
      result({ data }) {
        if (data && data.getDependent) {
          const { dependent, relation } = data.getDependent;
          if (dependent && dependent.length > 0) {
            let dependentList = [];
            this.isFormDirty = true;
            for (let depend of dependent) {
              let dependentOnj = {
                dFirstName: depend.Dependent_First_Name,
                dLastName: depend.Dependent_Last_Name,
                dRelation: depend.Relationship,
                dDob: depend.Dependent_DOB,
                nationality: depend.Nationality,
                isAdopted: depend.Is_Adopted,
                dAdoptionDate: depend.Adoption_Date,
                dependentId: depend.Dependent_Id,
                gender: depend.Gender_Id,
                dependentDobModal: false,
                dependentAdoptionDateModal: false,
                dAddress: depend.Dependent_Address,
                dMobileNumber: depend.Dependent_Mobile_Number,
                dPAN: depend.Dependent_PAN,
                epfNomination: depend.EPP_Nomination_Percentage,
                epsNomination: depend.EPS_Nomination_Percentage,
                insuranceNomination: depend.Insurance_Nomination_Percentage,
                othersNomination: depend.Others_Nomination_Percentage,
                gratuityNomination: depend.Gratuity_Nomination_Percentage,
                emergencyContactReference: depend.Emergency_Contact_Reference,
              };
              dependentList.push(dependentOnj);
            }
            this.addDependent = dependentList;
          }
          if (
            !this.noDependents &&
            this.addDependent.length === 0 &&
            relation.length === 0
          ) {
            this.addDependent.push({
              dFirstName: "",
              dLastName: "",
              dRelation: "",
              dDob: "",
              nationality: "",
              isAdopted: 0,
              dAdoptionDate: "",
              dependentId: 0,
              gender: null,
              dependentDobModal: false,
              dependentAdoptionDateModal: false,
              dAddress: "",
              dMobileNumber: "",
              dPAN: "",
              epfNomination: null,
              epsNomination: null,
              insuranceNomination: null,
              othersNomination: null,
              gratuityNomination: null,
              emergencyContactReference: null,
            });
          }
          if (relation && relation.length > 0) {
            this.relative = {
              name: relation[0].Relation_Name,
              position: relation[0].Position_Code,
              id: relation[0].Relation_Id,
              department: relation[0].Department,
            };
          }
        }
      },
    },
  },

  mounted() {
    scrollScreenToTop();
    this.getFieldProps();
    if (this.personalInfo) {
      this.checkRelative = this.personalInfo.Relative_In_Company;
    }
  },

  computed: {
    formatDate() {
      return (date) => {
        return date ? moment(date).format("DD/MM/YYYY") : "";
      };
    },
    presentNominationDetails() {
      const nominationIds = [1030, 1031, 1032, 1033, 1034, 1035];

      return nominationIds.some(
        (id) => this.formList[id]?.Field_Visiblity?.toLowerCase() === "yes"
      );
    },
  },

  watch: {
    relativeTabSaved(val) {
      if (val && this.dependentTabSaved) {
        this.$emit("dependent-saved");
      }
    },
    dependentTabSaved(val) {
      if (val && this.relativeTabSaved) {
        this.$emit("dependent-saved");
      }
    },
    checkRelative(val) {
      if (val) this.$emit("add-dependent");
    },
  },

  methods: {
    onClickRelativeToggle() {
      if (!this.checkRelative && this.relative.id) {
        this.removeRelative(this.relative.id);
      }
    },
    getFieldProps() {
      let vm = this;
      vm.formListLoader = true;
      this.$apollo
        .query({
          query: GET_FORM_FIELDS_AND_TYPE,
          variables: {
            form_Id: 178,
          },
          fetchPolicy: "no-cache",
          client: "apolloClientB",
        })
        .then((res) => {
          if (
            res.data.getFormFeildsByFormIdAndTab &&
            res.data.getFormFeildsByFormIdAndTab.formFields &&
            res.data.getFormFeildsByFormIdAndTab.formFields.length > 0
          ) {
            res.data.getFormFeildsByFormIdAndTab.formFields.forEach((list) => {
              this.formList[list.Field_Id] = list;
            });
            if (
              (this.formList[463] &&
                this.formList[463].Mandatory_Field &&
                this.formList[463].Mandatory_Field.toLowerCase() == "yes") ||
              this.relative.id
            ) {
              this.checkRelative = true;
            } else {
              this.checkRelative = false;
            }
          }
          vm.formListLoader = false;
        })
        .catch(() => {
          vm.formListLoader = false;
        });
    },
    handleNominationInput() {
      this.isFormDirty = true;
    },
    addMoreDependent() {
      this.validateDependent().then((isValid) => {
        if (isValid) {
          if (this.noDependents) {
            this.$emit("add-dependent");
          }
          this.addDependent.push({
            dFirstName: "",
            dLastName: "",
            dRelation: "",
            dDob: "",
            nationality: "",
            dAdoptionDate: "",
            isAdopted: 0,
            dependentId: 0,
            gender: null,
            dependentDobModal: false,
            dependentAdoptionDateModal: false,
            dAddress: "",
            dMobileNumber: "",
            dPAN: "",
            epfNomination: null,
            epsNomination: null,
            insuranceNomination: null,
            othersNomination: null,
            gratuityNomination: null,
            emergencyContactReference: null,
          });
        }
      });
    },

    deleteAllRelatives() {
      let dependentDuplicate = JSON.parse(JSON.stringify(this.addDependent)); //this.addDependent;
      for (let [index, dependent] of dependentDuplicate.entries()) {
        this.removeDependentDetails(index, dependent);
      }
      if (this.relative.id) {
        this.removeRelative(this.relative.id);
      }
    },

    validateDependent() {
      return new Promise((resolve) => {
        if (this.addDependent.length) {
          let callCount = 0,
            isValidCount = 0;
          for (let dIndex in this.addDependent) {
            this.$refs["dependentForm" + dIndex][0]
              .validate()
              .then((validationResponse) => {
                callCount += 1;
                if (validationResponse) {
                  isValidCount += 1;
                  if (callCount === this.addDependent.length) {
                    resolve(isValidCount === this.addDependent.length);
                  }
                }
              });
          }
        } else {
          resolve(true);
        }
      });
    },
    validateRelative() {
      return new Promise((resolve) => {
        this.$refs["relativeForm"].validate().then((isValid) => {
          let invalidFields = [];
          Object.keys(this.$refs).forEach((refName) => {
            const field = this.$refs[refName];
            if (field && field.errors && field.errors.length > 0) {
              invalidFields.push(refName);
            }
          });
          if (invalidFields.length > 0) {
            let firstField = this.$refs[invalidFields[0]];
            firstField.$el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
          resolve(isValid);
        });
      });
    },

    async onSaveDependent() {
      if (!this.noDependents) {
        this.apiCallCount = 0;
        let relativeValid = true,
          dependentValid = true;
        if (this.checkRelative) {
          await this.validateRelative().then((isValid) => {
            relativeValid = isValid;
          });
        }
        if (this.isFormDirty && !this.noDependents) {
          await this.validateDependent().then((isValid) => {
            if (!isValid) {
              dependentValid = false;
            }
          });
        }
        if (relativeValid && dependentValid) {
          if (this.checkRelative) {
            this.relativeTabSaved = false;
            if (this.relative.id) {
              this.updateRelative();
            } else {
              this.addRelative();
            }
          }
          if (this.isFormDirty) {
            this.dependentTabSaved = false;
            for (let dependent of this.addDependent) {
              this.apiCallCount += 1;
              if (dependent.dependentId) {
                this.updateDependentDetails(dependent);
              } else {
                this.addDependentDetails(dependent);
              }
            }
          }
        }
      }
      this.submitPersonalDetails();
    },
    submitPersonalDetails() {
      let vm = this;
      vm.saveLoading = true;
      let submitObj = {
        Org_Code: localStorage.getItem("orgCode"),
        Url_Hash: localStorage.getItem("urlHash"),
        Photo_Path: this.fileName,
        ...vm.personalInfo,
        Emergency_Contact_No: this.personalInfo?.Fax_No || null,
        No_Dependent: this.noDependents,
        Relative_In_Company: this.checkRelative,
        Personal_Custom_Field1: this.personalInfo.Custom_Field_1,
        Personal_Custom_Field2: this.personalInfo.Custom_Field_2,
        Personal_Custom_Field3: this.personalInfo.Custom_Field_3,
        Personal_Custom_Field4: this.personalInfo.Custom_Field_4,
        Personal_Custom_Field5: this.personalInfo.Custom_Field_5,
        Personal_Custom_Field6: this.personalInfo.Custom_Field_6,
        Personal_Custom_Field7: this.personalInfo.Custom_Field_7,
        Personal_Custom_Field8: this.personalInfo.Custom_Field_8,
        Personal_Custom_Field9: this.personalInfo.Custom_Field_9,
        Personal_Custom_Field10: this.personalInfo.Custom_Field_10,
      };
      vm.$apollo
        .mutate({
          mutation: UPDATE_PERSONAL_INFO,
          variables: submitObj,
          client: "apolloClientA",
        })
        .then(() => {
          vm.saveLoading = false;
          this.$emit("dependent-saved");
        })
        .catch((updateErr) => {
          vm.saveLoading = false;
          let snackbarData = {
            isOpen: true,
            message:
              updateErr.graphQLErrors.length !== 0
                ? updateErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error.",
            type: "warning",
          };
          vm.showAlert(snackbarData);
        });
    },

    addRelative() {
      let vm = this;
      vm.$apollo
        .mutate({
          mutation: ADD_UPDATE_RELATIVE,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Is_Update: 0,
            relationDetails: [
              {
                Relation_Name: vm.relative.name,
                Position_Code: vm.relative.position,
                Department: vm.relative.department,
              },
            ],
            client: "apolloClientA",
          },
        })
        .then(() => {
          this.relativeTabSaved = true;
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors && addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
        });
    },
    updateRelative() {
      let vm = this;
      vm.$apollo
        .mutate({
          mutation: ADD_UPDATE_RELATIVE,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Is_Update: 1,
            relationDetails: [
              {
                Relation_Id: vm.relative.id,
                Relation_Name: vm.relative.name,
                Position_Code: vm.relative.position,
                Department: vm.relative.department,
              },
            ],
            client: "apolloClientA",
          },
        })
        .then(() => {
          this.relativeTabSaved = true;
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors && addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
        });
    },

    removeRelative(id) {
      let vm = this;
      vm.$apollo
        .mutate({
          mutation: REMOVE_RELATIVE,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Relation_Id: id,
          },
          client: "apolloClientA",
        })
        .then(() => {
          this.relative = {};
          this.checkRelative = false;
          let snackbarData = {
            isOpen: true,
            message: "Relative details deleted successfully",
            type: "success",
          };
          vm.showAlert(snackbarData);
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors && addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
        });
    },

    onSkipDependent() {
      this.$emit("dependent-saved");
    },

    addDependentDetails(dependentItem) {
      let vm = this;
      vm.saveLoading = true;
      let genderTitle = this.genderList.filter((e) => {
        if (e.genderId == dependentItem.gender) {
          return e.gender;
        }
      });

      const getNumericValue = (value) => {
        const parsedValue = parseFloat(value);
        return Number.isNaN(parsedValue) ? null : parsedValue;
      };
      vm.$apollo
        .mutate({
          mutation: ADD_DEPENDENT,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Dependent_First_Name: dependentItem.dFirstName,
            Dependent_Last_Name: dependentItem.dLastName,
            Gender_Id: dependentItem.gender,
            Gender: genderTitle[0]?.gender,
            Relationship: dependentItem.dRelation,
            Dependent_DOB:
              dependentItem.dDob && dependentItem.dDob != "Invalid date"
                ? dependentItem.dDob
                : null,
            Nationality: dependentItem.nationality,
            Dependent_Address: dependentItem.dAddress,
            Dependent_Mobile_Number: dependentItem.dMobileNumber,
            Dependent_PAN: dependentItem.dPAN,
            EPP_Nomination_Percentage: getNumericValue(
              dependentItem.epfNomination
            ),
            EPS_Nomination_Percentage: getNumericValue(
              dependentItem.epsNomination
            ),
            Insurance_Nomination_Percentage: getNumericValue(
              dependentItem.insuranceNomination
            ),
            Others_Nomination_Percentage: getNumericValue(
              dependentItem.othersNomination
            ),
            Gratuity_Nomination_Percentage: getNumericValue(
              dependentItem.gratuityNomination
            ),
            Emergency_Contact_Reference:
              dependentItem.emergencyContactReference,
            Is_Adopted: dependentItem.isAdopted,
            Adoption_Date:
              dependentItem.dAdoptionDate &&
              dependentItem.dAdoptionDate != "Invalid date" &&
              dependentItem.isAdopted
                ? dependentItem.dAdoptionDate
                : null,
          },
          client: "apolloClientA",
        })
        .then(() => {
          if (vm.apiCallCount === this.addDependent.length) {
            this.dependentTabSaved = true;
          }
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
          if (vm.apiCallCount === this.addDependent.length) {
            vm.saveLoading = false;
          }
        });
    },

    updateDependentDetails(dependentItem) {
      let vm = this;
      vm.saveLoading = true;
      let genderTitle = this.genderList.filter((e) => {
        if (e.genderId == dependentItem.gender) {
          return e.gender;
        }
      });

      const getNumericValue = (value) => {
        const parsedValue = parseFloat(value);
        return Number.isNaN(parsedValue) ? null : parsedValue;
      };
      vm.$apollo
        .mutate({
          mutation: UPDATE_DEPENDENT,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Dependent_Id: dependentItem.dependentId,
            Dependent_First_Name: dependentItem.dFirstName,
            Dependent_Last_Name: dependentItem.dLastName,
            Gender_Id: dependentItem.gender,
            Gender: genderTitle[0]?.gender,
            Relationship: dependentItem.dRelation,
            Dependent_DOB:
              dependentItem.dDob && dependentItem.dDob != "Invalid date"
                ? dependentItem.dDob
                : null,
            Nationality: dependentItem.nationality,
            Dependent_Address: dependentItem.dAddress,
            Dependent_Mobile_Number: dependentItem.dMobileNumber,
            Dependent_PAN: dependentItem.dPAN,
            EPP_Nomination_Percentage: getNumericValue(
              dependentItem.epfNomination
            ),
            EPS_Nomination_Percentage: getNumericValue(
              dependentItem.epsNomination
            ),
            Insurance_Nomination_Percentage: getNumericValue(
              dependentItem.insuranceNomination
            ),
            Others_Nomination_Percentage: getNumericValue(
              dependentItem.othersNomination
            ),
            Gratuity_Nomination_Percentage: getNumericValue(
              dependentItem.gratuityNomination
            ),
            Emergency_Contact_Reference:
              dependentItem.emergencyContactReference,
            Is_Adopted: dependentItem.isAdopted,
            Adoption_Date:
              dependentItem.dAdoptionDate &&
              dependentItem.dAdoptionDate != "Invalid date" &&
              dependentItem.isAdopted
                ? dependentItem.dAdoptionDate
                : null,
          },
          client: "apolloClientA",
        })
        .then(() => {
          if (vm.apiCallCount === this.addDependent.length) {
            this.dependentTabSaved = true;
          }
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
          if (vm.apiCallCount === this.addDependent.length) {
            vm.saveLoading = false;
          }
        });
    },

    removeDependentDetails(index, dependentItem) {
      if (dependentItem.dependentId) {
        let vm = this;
        let dependentIndex = this.addDependent.indexOf(dependentItem);
        this.addDependent.splice(dependentIndex, 1);
        this.$apollo
          .mutate({
            mutation: DELETE_DEPENDENT,
            variables: {
              Org_Code: localStorage.getItem("orgCode"),
              Url_Hash: localStorage.getItem("urlHash"),
              Dependent_Id: dependentItem.dependentId,
            },
            client: "apolloClientA",
          })
          .then(() => {
            let snackbarData = {
              isOpen: true,
              message: "Deleted Successfully",
              type: "success",
            };
            vm.showAlert(snackbarData);
          })
          .catch((deleteErr) => {
            let snackbarData = {
              isOpen: true,
              message:
                deleteErr.graphQLErrors.length !== 0
                  ? deleteErr.graphQLErrors[0].message
                  : "Something went wrong. It could be a possibility due to network connectivity error..",
              type: "warning",
            };
            vm.showAlert(snackbarData);
          });
      } else {
        this.addDependent.splice(index, 1);
      }
    },

    // show error or success message
    showAlert(snackbarData) {
      this.$store.commit("OPEN_SNACKBAR", snackbarData);
    },
  },
};
</script>
